import { useMutation } from 'query';
import { createStripeDonationPayment } from '../../services/createStripeDonationPayment';

export const useStripeDonationPayment = () =>
  useMutation<{ checkoutUrl: string }, { id: string; pathname: string }>(async ({ id, pathname }) => {
    const response = await createStripeDonationPayment(id, { pathname });
    return { checkoutUrl: response.data.checkout_url };
  });
